export const MULTIPLE_CHOICES = ['A', 'B', 'C', 'D', 'E'];

export const DIGITAL_TIMER_WARNING_TIME = 300;